export const setDocumentHeadLinks = () => {
  const appleLink = document.getElementById(
    'sz-apple-touch-icon'
  ) as HTMLLinkElement;
  const smallLogoLink = document.getElementById(
    'sz-logo-16x16'
  ) as HTMLLinkElement;
  const mediumLogoLink = document.getElementById(
    'sz-logo-32x32'
  ) as HTMLLinkElement;
  const faviconLink = document.getElementById('sz-favicon') as HTMLLinkElement;
  const server = import.meta.env.VITE_SERVER;
  if (server === 'dev' || server === 'dev2' || server === 'stg' || server === 'staging') {
    appleLink.href = `/icons/dev/icon_270x270.svg`;
    smallLogoLink.href = `/icons/dev/icon_16x16.svg`;
    mediumLogoLink.href = `/icons/dev/icon_32x32.svg`;
    faviconLink.href = `/icons/dev/icon_32x32.svg`;
  }
};

